module.exports = __webpack_public_path__ + "static/media/venn_diagram.a0e5786e.webp";